import styled from 'styled-components';
import { renderRatio } from '@styles/utils';

export const BucketImageContainer = styled.div<{ ratio?: number }>`
  ${props => renderRatio(props.ratio)};
`;
